import React from "react";

/**
 * Componente del icono de Setup Técnico (Checklist sin anillas)
 * @param {number} size - Tamaño del icono en píxeles
 * @param {object} props - Props adicionales para el SVG
 */
export const SetupIcon = ({ size = 24, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        {/* Rectángulo principal con esquinas redondeadas */}
        <rect x="3" y="2" width="18" height="20" rx="2.5" ry="2.5" />

        {/* Primera fila - Checkmark */}
        <path d="M 6.5 7 L 8 8.5 L 10 6" />
        {/* Primera línea */}
        <rect x="12" y="6.5" width="6" height="1.5" rx="0.75" fill="currentColor" stroke="none" />

        {/* Segunda fila - Checkmark */}
        <path d="M 6.5 11.5 L 8 13 L 10 10.5" />
        {/* Segunda línea */}
        <rect x="12" y="11" width="6" height="1.5" rx="0.75" fill="currentColor" stroke="none" />

        {/* Tercera fila - Checkmark */}
        <path d="M 6.5 16 L 8 17.5 L 10 15" />
        {/* Tercera línea */}
        <rect x="12" y="15.5" width="6" height="1.5" rx="0.75" fill="currentColor" stroke="none" />
    </svg>
);